// One shared player for audio cards (music, SFX, voice samples), so tapping a second sample stops the first.
import { set, toast } from "./store";

let el: HTMLAudioElement | null = null;
let current: string | null = null;

export function toggleAudio(key: string, url: string | undefined | null) {
  if (!url) {
    toast("That sound isn't ready to play yet.", "bad");
    return;
  }
  if (current === key && el && !el.paused) {
    el.pause();
    current = null;
    set({ playing: null });
    return;
  }
  el?.pause();
  el = new Audio(url);
  current = key;
  set({ playing: key });
  el.onended = el.onerror = () => {
    if (current === key) {
      current = null;
      set({ playing: null });
    }
  };
  el.play().catch(() => {
    current = null;
    set({ playing: null });
  });
}

export function stopAudio() {
  el?.pause();
  current = null;
  set({ playing: null });
}
